module.exports = __webpack_public_path__ + "img/beian-logo.d0289dc0.png";